import React, {useState} from 'react';
import styled from "styled-components";
// import { AiOutlineArrowUp }
// import { IoIosArrowForward } from "react-icons/io";
import { Link } from "react-scroll";
import image from "./Assets/unib.png"
import {FiMenu} from "react-icons/fi"
import { NavLink } from 'react-router-dom';

const Header = () => {

    const [show, setShow] = React.useState(false);
    const [drop, setDrop] = useState(false)
    const [isShown, setIsShown] = useState(false);
    const [faculty, setFaculty] = useState(false);

    const Fac = () => {
        setFaculty(!faculty)
        setIsShown(false)
    }

    const Shows = () => {
        setIsShown(!isShown)
        setFaculty(false)
    }

    const Toggle = () => {
        setDrop(!drop)
    }

	const changeHeaderColor = () => {
		if (window.scrollY >= 70) {
			setShow(true);
		} else {
			setShow(false);
		}
	};

	window.addEventListener("scroll", changeHeaderColor);

  return (
    <>
    {show ? (
        <Container bg='#fff' >
            {faculty ? (
                <Drops>
                    <One>Team</One>
                    <One>Trainning for Proposal writting</One>
                    <One>Trainning for Presentation</One>
                </Drops>
            ) : null}
            {isShown ? (
                <Drop>
                    <One>Need a Research Collaborator</One>
                    <One>Need a Research Mentor</One>
                    <NavLink to="research">
                        <One>Researchers</One>
                    </NavLink>
                    <One>Eligibility</One>
                </Drop>
            ) : null}
        <Wrapper>
            <Logo>
                <Img src={image} />
            </Logo>
            
            <Navigation>
                
                <NavLink to="/" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Home</Nav>
                </NavLink>
                <NavLink to="/about" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>About</Nav>
                </NavLink>
                <NavLink to="/gallery" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Gallery</Nav>
                </NavLink>
                    <Nav onClick={Shows}>Students</Nav>
                    <Nav onClick={Fac}>Faculty</Nav>
                <NavLink to="/contact" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Contact</Nav>
                </NavLink>
                <NavLink to="/journal" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Journal</Nav>
                </NavLink>
            </Navigation>
            <NavLink to="/apply" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                <Button>
                <h5>Apply</h5>
            </Button>
            </NavLink>
            <Hamburger onClick={Toggle}>
                <FiMenu />
            </Hamburger>
            {drop ? (
                <Dropdown>
                     <Drop>

                </Drop>
                    <Card>
                       
                        <NavLink to="/" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>Home</Navhold>
                        </NavLink>
                        <NavLink to="/about" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>About</Navhold>
                        </NavLink>
                        <NavLink to="/gallery" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>Gallery</Navhold>
                        </NavLink>
                            <Navhold>Students</Navhold>
                            <Navhold>Faculty</Navhold>
                        <NavLink to="/contact" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>Contact</Navhold>
                        </NavLink>
                        <Navhold>Journal</Navhold>
                        <NavLink to="/apply" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Button2>
                            Apply
                        </Button2>
                        </NavLink>
                    </Card>
                </Dropdown>
            ) : null}
        </Wrapper>
    </Container>
    ) : (
        <Container bg='#fff'>
            {faculty ? (
                <Drops>
                    <One>Team</One>
                    <One>Trainning for Proposal writting</One>
                    <One>Trainning for Presentation</One>
                </Drops>
            ) : null}
            {isShown ? (
                <Drop>
                    <One>Need a Research Collaborator</One>
                    <One>Need a Research Mentor</One>
                    <NavLink to="research">
                        <One>Researchers</One>
                    </NavLink>
                    <One>Eligibility</One>
                </Drop>
            ) : null}
        <Wrapper>
            <Logo>
                <Img src={image} />
            </Logo>
            
            <Navigation>
                
                <NavLink to="/" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Home</Nav>
                </NavLink>
                <NavLink to="/about" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>About</Nav>
                </NavLink>
                <NavLink to="/gallery" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Gallery</Nav>
                </NavLink>
                    <Nav onClick={Shows}>Students</Nav>
                    <Nav onClick={Fac}>Faculty</Nav>
                <NavLink to="/contact" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Contact</Nav>
                </NavLink>
                <NavLink to="/journal" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                    <Nav>Journal</Nav>
                </NavLink>
            </Navigation>
            <NavLink to="/apply" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                <Button >
                <h5>Apply</h5>
            </Button>
            </NavLink>
            <Hamburger onClick={Toggle}>
                <FiMenu />
            </Hamburger>
            {drop ? (
                <Dropdown>
                    <Drop>

                </Drop>
                    <Card>
                        
                        <NavLink to="/" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>Home</Navhold>
                        </NavLink>
                        <NavLink to="/about" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>About</Navhold>
                        </NavLink>
                        <NavLink to="/gallery" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>Gallery</Navhold>
                        </NavLink>
                        <NavLink to="/contact" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
    <Navhold>Students</Navhold>
    <Navhold>Faculty</Navhold>
                        </NavLink>
                        <NavLink to="/contact" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Navhold>Contact</Navhold>
                        </NavLink>
                        <Navhold>Journal</Navhold>
                        <NavLink to="/apply" style={({ isActive }) => ({
    textDecoration: "none",
    color: isActive ? '#219653' : '#5f5f5f'
  })}>
                            <Button3>
                            Apply
                        </Button3>
                        </NavLink>
                    </Card>
                </Dropdown>
            ) : null}
        </Wrapper>
        </Container>
        )}
    </>
);
};

export default Header;
const One = styled.div`
    font-size: 17px;
    color: #5f5f5f;
    cursor: pointer;
    margin-top: 15px;
`
const Drops = styled.div`
    width: 280px;
    height: 200px;
    display: flex;
    background-color: white;
    position: absolute;
    /* margin-top: 180px; */
    top: 80px;
    z-index: 727267373;
    margin-left: 250px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    flex-direction: column;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`
const Drop = styled.div`
    width: 280px;
    height: 200px;
    display: flex;
    background-color: white;
    position: absolute;
    /* margin-top: 180px; */
    top: 80px;
    z-index: 727267373;
    margin-left: 100px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    flex-direction: column;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`
const Card = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    position: relative;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    background-color: white;
`
const Dropdown = styled.div`
    position: absolute;
    background-color: rgba(0, 0, 0, 0.4);
    height: 700px;
    display: flex;
    position: fixed;
    right: 0;
    left: 0;
    top: 80px;
    justify-content: flex-end;
    width: 100%;
    /* flex-direction: column; */
    /* align-items: center; */
    /* transform: translateY(100%); */
    transition: all 350ms;
`
const Hamburger = styled.div`
    display: flex;
    align-items: center;
    color: black;
    font-size: 30px;
    display: none;
    @media screen and (max-width: 900px) {
        display: flex;
    }
    @media screen and (max-width: 768px) {
        margin-right: 15px;
    }
`
const Img = styled.img`
    height: 70px;
`

const Container = styled.div<{ bg: string; }>`
    height: 80px;
    width: 100%;
    background-color: ${(props) => props.bg};
    border-bottom: #f1f1f1;
    display: flex;
    /* overflow: hidden; */
    align-items: center;
    justify-content: center;
    position: sticky;
	top: 0;
	z-index: 19189;
    position: fixed;
	transition: all 350ms;
`;
const Wrapper = styled.div`
    height: 50px;
    width: 90%;
    display: flex;
    /* overflow: hidden; */
    position: relative;
    align-items: center;
    justify-content: space-between;
`;
const Logo = styled.div`
    h1{
        font-size: xx-large;
        font-weight: bolder;
    }
    align-items: center;
    display: flex;
`;
const Navigation = styled.div`
    width: 680px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
        display: none;
    }
    /* cursor: pointer; */
    /* background-color: red; */
`;
const Navhold = styled.div`
    font-weight: bolder;
    cursor: pointer;
    color: #444444;
    margin-bottom: 10px;
    margin-top: 40px;
`;
const Nav = styled.div`
    font-weight: bolder;
    cursor: pointer;
    color: #5f5f5f;
    :hover{
        border-bottom: 7px solid #00A85A;
        line-height: 50px;
    }
`;
const Button3 = styled.div`
    height: 50px;
    width: 150px;
    background-color:  #00A85A;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    cursor: pointer;
    transition: all 350ms;
    font-weight: bold;
	color: white;
    margin-top: 25px;
    :hover{
        transform: scale(0.9);
        background-color: #F5F5F5;
        color: #00A85A;
        border: 1px solid #00A85A;
    };
`;
const Button2 = styled.div`
    height: 50px;
    width: 150px;
    background-color:  #00A85A;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    cursor: pointer;
    transition: all 350ms;
    font-weight: bold;
	color: white;
    :hover{
        transform: scale(0.9);
        background-color: #F5F5F5;
        color: #00A85A;
        border: 1px solid #00A85A;
    };
`;
const Button = styled.div`
    height: 50px;
    width: 150px;
    background-color:  #00A85A;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    cursor: pointer;
    transition: all 350ms;
    font-weight: bold;
	color: white;
    :hover{
        transform: scale(0.9);
        background-color: #F5F5F5;
        color: #00A85A;
        border: 1px solid #00A85A;
    };
    @media screen and (max-width: 900px) {
        display: none;
    }
`;